import router from './router'
import store from './store'
import NProgress from 'nprogress'


const loginPath = '/login'
const defaultPath = '/'
// FIX: 扩展白名单，包含不需要登录的页面
const whiteList = ['/login', '/', '/index', '/about', '/search']
NProgress.configure({ showSpinner: false }) 

router.beforeEach((to, from, next) => {
    NProgress.start()
    // 设置文档title
    to.meta?.title && (document.title = to.meta.title)
    
    // FIX: 移除URL query参数传递token的方式，改为从store获取
    // let { token } = to.query
    // if(token) {
    //     store.commit('SET_TOKEN', token)
    // }
    
    const token = store.getters.token;
    
    if (token) {
        // 已登录
        if (to.path === loginPath) {
            next({ path: defaultPath })
        } else {
            next();
        }
    } else {
        // 未登录
        // FIX: 检查目标路由是否在白名单中
        if (whiteList.includes(to.path)) {
            // 在白名单中，允许访问
            next()
        } else {
            // 不在白名单中，重定向到登录页
            next({ path: loginPath, query: { redirect: to.path } })
        }
    }

})


router.afterEach(() => {
    NProgress.done()
})
